import { Events } from '../../js/services/Events/Events';
import * as actiontypes from '../types';
import axios from 'axios';
export const FinancingPageDetails = {
  state: {
    e_lendDisclosure: {},
    dealerTrackResponse: '',
    dealerTrackRequest: '',
    dealerTrackRefId: '',
    campaignId: parseInt(window.campaignId),
    accountId: parseInt(window.accountId),
    dealerTrackBaseUrl: 'https://dev.dealertrack.api.teamvelocityportal.com/api',
    logLeadData: '',
    firstName: '',
    lastName: '',
    stepOneData: {
      firstnamefield: '',
      lastnamefield: '',
      middleName: '',
      emailfield: '',
      zipfield: '',
      phonefield: '',
    },
    stepOneValidationError: false,
    stepTwoValidationError: false,
    cbcApiResponse: '',
    webservicepayload: {},
    eSignSignatureError: false,
    popupStatus: true,
    eventDrivenSessionCount: 0,
    currentstep: 1,
    successmessage: '',
    currentComponent: 'financing-step-1',
    iscoapplicant: '',
    logleadsaveid: 0,
    isloading: false,
    showTextModal: false,
    errormessage: '',
    elendSuccess: false,
    elendError: false,
    postdata: {
      vehicleCondition: '',
      'form-id': window.financeAppDealerCode,
      'lead-id-field': '',
      employerclassfield: '',
      relationshipfield: '',
      formeremployerclassfield: '',
      phonefield: '',
      statusnote: '',
      locationfield: '',
      datepicker: '',
      ssnfield: '',
      driverlicensefield: '',
      driverlicensestatefield: '',
      streetfield: '',
      citytfield: '',
      statefield: '',
      zipfield: '',
      rentorownfield: '',
      monthlypaymentfield: '',
      addressyearstotalfield: '',
      addressmonthstotalfield: '',
      employerfield: '',
      employercitytfield: '',
      employerstatefield: '',
      workphonefield: '',
      titlefield: '',
      employmentyearsfield: '',
      employmentmonthsfield: '',
      incomefield: '',
      additionalincomefield: '',
      additionalincomesourcefield: '',
      cosignerfirstnamefield: '',
      ccosignerlastnamefield: '',
      cosigneremailfield: '',
      cosignermobilephonefield: '',
      cosignerdateofbirthfield: '',
      cosignerssnfield: '',
      codriverlicensefield: '',
      codriverlicensestatefield: '',
      cosignerstreetfield: '',
      cosignercitytfield: '',
      cosignerstatefield: '',
      cosignerzipfield: '',
      cosignerrentorownfield: '',
      cosignermonthlypaymentfield: '',
      cosigneraddressyearstotalfield: '',
      cosigneraddressmonthstotalfield: '',
      cosigneremployerfield: '',
      cosigneremployercityfield: '',
      cosigneremployerstatefield: '',
      cosigneremploymerphonefield: '',
      cosignerpositionfield: '',
      cosigneremploymentlengthyearsfield: '',
      cosigneremploymentmonthsfield: '',
      cosignermonthlyincomefield: '',
      cosigneradditionalincomefield: '',
      cosigneradditionalincomesourcefield: '',
      additionalinformationfield: '',
      privacypolicyfield: false,
      previousstreetfield: '',
      previouscitytfield: '',
      previousstatefield: '',
      previouszipfield: '',
      previousaddressyearstotalfield: '',
      previousaddressmonthstotalfield: '',
      formeremployerfield: '',
      formeremployeraddressfield: '',
      formeremployercityfield: '',
      formeremployerstatefield: '',
      formeremployerzipfielde: '',
      formeremployerpositionfield: '',
      formerincomefield: '',
      formeremployertimefield: '',
      formeremployertimemonthsfield: '',
      formeremployerleavereasonfield: '',
      formeremployerphonefield: '',
      cosignerrelationshipfield: '',
      cosigneremployerclassfield: '',
      sessionId: window.tid,
      payperiodfield: 'Monthly',
      cosignerpayperiodfield: 'Monthly',
    },
    creditR1PostData: {
      financeType: '',
      relationshipDescription: '',
      pricing: {
        currency: 'USD',
        price: '',
        type: '',
      },
    },
    creditPostData: {
      campaignId: parseInt(window.campaignId),
      accountId: parseInt(window.accountId),
      logLeadItemID: 0,
      applicationId: 0,
      vehicle: {
        vin: '',
        year: 0,
        make: '',
        model: '',
        trim: '',
      },
      applicants: [
        {
          type: 'Primary',
          relationship: '',
          firstName: '',
          middleName: '',
          lastName: '',
          suffix: '',
          ids: [
            {
              type: 'DL',
              issuer: '',
              value: '',
            },
            {
              type: 'SSN',
              issuer: 'USA',
              value: '',
            },
          ],
          dateOfBirth: '',
          otherMonthlyIncome: 0,
          otherIncomeDescription: '',
          housing: {
            type: '',
            payment: 0,
          },
          emailAddress: '',
          phoneNumbers: [
            {
              type: 'cell',
              areaCode: '',
              prefix: '',
              suffix: '',
              extension: '',
            },
          ],
          addresses: [
            {
              type: 'Current',
              addressLine1: '',
              addressLine2: '',
              city: '',
              county: '',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
            },
            {
              type: 'Previous',
              addressLine1: '',
              addressLine2: '',
              city: '',
              county: '',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
            },
          ],
          employers: [
            {
              type: 'Current',
              class: '',
              name: '',
              positionTitle: '',
              yearsAtEmployer: 0,
              monthsAtEmployer: 0,
              phoneNumber: {
                type: 'work',
                areaCode: '',
                prefix: '',
                suffix: '',
                extension: '',
              },
              address: {
                type: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                county: '',
                state: '',
                postalCode: '',
                yearsAtAddress: 0,
                monthsAtAddress: 0,
              },
              grossMonthlyIncome: 0,
            },
            {
              type: 'Previous',
              class: '',
              name: '',
              positionTitle: '',
              yearsAtEmployer: 0,
              monthsAtEmployer: 0,
              phoneNumber: {
                type: 'work',
                areaCode: '',
                prefix: '',
                suffix: '',
                extension: '',
              },
              address: {
                type: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                county: '',
                state: '',
                postalCode: '',
                yearsAtAddress: 0,
                monthsAtAddress: 0,
              },
              grossMonthlyIncome: 0,
            },
          ],

          // bank: {
          //   bankName: '',
          //   accountType: '',
          // },
        },
        {
          type: 'Cobuyer',
          relationship: '',
          firstName: '',
          middleName: '',
          lastName: '',
          suffix: '',
          ids: [
            {
              type: 'DL',
              issuer: '',
              value: '',
            },
            {
              type: 'SSN',
              issuer: 'USA',
              value: '',
            },
          ],
          dateOfBirth: '',
          otherMonthlyIncome: 0,
          otherIncomeDescription: '',
          housing: {
            type: '',
            payment: 0,
          },
          emailAddress: '',
          phoneNumbers: [
            {
              type: 'cell',
              areaCode: '',
              prefix: '',
              suffix: '',
              extension: '',
            },
          ],
          addresses: [
            {
              type: 'Current',
              addressLine1: '',
              addressLine2: '',
              city: '',
              county: '',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
            },
            {
              type: 'Previous',
              addressLine1: '',
              addressLine2: '',
              city: '',
              county: '',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
            },
          ],
          employers: [
            {
              type: 'Current',
              class: '',
              name: '',
              positionTitle: '',
              yearsAtEmployer: 0,
              monthsAtEmployer: 0,
              phoneNumber: {
                type: 'work',
                areaCode: '',
                prefix: '',
                suffix: '',
                extension: '',
              },
              address: {
                type: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                county: '',
                state: '',
                postalCode: '',
                yearsAtAddress: 0,
                monthsAtAddress: 0,
              },
              grossMonthlyIncome: 0,
            },
          ],

          bank: {
            bankName: '',
            accountType: '',
          },
        },
      ],
      sessionId: window.tid,
    },
    financeVehicleDataByVIN: {
      year: 0,
      make: '',
      model: '',
      trim: '',
      vehicleStockNumber: '',
      vehicleVin: '',
    },
    creditCBCPostData: {
      campaignId: parseInt(window.campaignId),
      accountId: parseInt(window.accountId),
      logLeadItemID: 0,
      applicants: [
        {
          type: 'Primary',
          firstName: '',
          lastName: '',
          addresses: [
            {
              type: 'Current',
              addressLine: '',
              city: '',
              country: 'USA',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
              status: '',
              PaymentAmount: '',
            },
            {
              type: 'Previous',
              addressLine: '',
              city: '',
              country: 'USA',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
              status: '',
            },
          ],
          employers: [
            {
              type: 'Current',
              class: '',
              name: '',
              positionTitle: '',
              yearsAtEmployer: 0,
              monthsAtEmployer: 0,
              phoneNumber: {
                type: 'Cell',
                areaCode: '',
                prefix: '',
                suffix: '',
              },
              address: {
                addressLine: '',
                city: '',
                country: 'USA',
                state: '',
                postalCode: '',
              },
              grossMonthlyIncome: 0,
            },
            {
              type: 'Previous',
              class: '',
              name: '',
              positionTitle: '',
              yearsAtEmployer: 0,
              monthsAtEmployer: 0,
              phoneNumber: {
                type: 'Cell',
                areaCode: '',
                prefix: '',
                suffix: '',
              },
              address: {
                addressLine: '',
                city: '',
                country: 'USA',
                state: '',
                postalCode: '',
              },
              grossMonthlyIncome: 0,
            },
          ],
          otherMonthlyIncome: 0,
          otherIncomeDescription: '',
          dateOfBirth: '',
          emailAddress: '',
          phoneNumbers: [
            {
              type: 'Cell',
              areaCode: '',
              prefix: '',
              suffix: '',
            },
          ],
          ids: [
            {
              type: 'SSN',
              issuer: 'USA',
              value: '',
            },
            {
              type: 'DL',
              issuer: '',
              value: '',
            },
          ],
        },
        {
          type: 'Cobuyer',
          firstName: '',
          lastName: '',
          addresses: [
            {
              type: 'Current',
              addressLine: '',
              city: '',
              country: 'USA',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
              status: '',
              PaymentAmount: '',
            },
            {
              type: 'Previous',
              addressLine: '',
              city: '',
              country: 'USA',
              state: '',
              postalCode: '',
              yearsAtAddress: 0,
              monthsAtAddress: 0,
              status: '',
            },
          ],
          employers: [
            {
              type: 'Current',
              class: '',
              name: '',
              positionTitle: '',
              yearsAtEmployer: 0,
              monthsAtEmployer: 0,
              phoneNumber: {
                type: 'Cell',
                areaCode: '',
                prefix: '',
                suffix: '',
              },
              address: {
                addressLine: '',
                city: '',
                country: 'USA',
                state: '',
                postalCode: '',
              },
              grossMonthlyIncome: 0,
            },
          ],
          dateOfBirth: '',
          emailAddress: '',
          phoneNumbers: [
            {
              type: 'Cell',
              areaCode: '',
              prefix: '',
              suffix: '',
            },
          ],
          otherMonthlyIncome: 0,
          otherIncomeDescription: '',
          ids: [
            {
              type: 'SSN',
              issuer: 'USA',
              value: '',
            },
            {
              type: 'DL',
              issuer: '',
              value: '',
            },
          ],
        },
      ],
    },
  },

  mutations: {
    [actiontypes.E_LEND_DISCLOSURE_DATA](state, payload) {
      state.e_lendDisclosure = payload;
    },
    [actiontypes.DEALER_TRACK_RESPONSE](state, payload) {
      state.dealerTrackResponse = payload;
    },
    [actiontypes.DEALER_TRACK_REQUEST](state) {
      let data = { ...state.creditPostData };
      delete data.applicants[0].bank;
      if (window.hideVehicleOfInterest) {
        data.vehicle = null;
      } else {
        data.vehicle['inventoryVehicleCondition'] = state.postdata.vehicleCondition;
      }
      data['FinanceDetails'] = null;
      data['FinanceType'] = state.creditR1PostData.financeType;
      //redudant code need to refactor
      if (data.applicants[0].otherMonthlyIncome === 0) {
        delete data.applicants[0].otherMonthlyIncome;
      }
      data.applicants[0].employers[0].address.addressLine1 =
        data.applicants[0].employers[0].address.city;
      data.applicants[0].employers[0].address.addressLine2 =
        data.applicants[0].employers[0].address.city;
      data.applicants[0].employers[1].address.addressLine1 =
        data.applicants[0].employers[1].address.city;
      data.applicants[0].employers[1].address.addressLine2 =
        data.applicants[0].employers[1].address.city;

      data.applicants[0].employers[0].address.postalCode =
        data.applicants[0].addresses[0].postalCode;
      data.applicants[0]['income'] = data.applicants[0].employers[0].grossMonthlyIncome;
      data.applicants[0]['incomeFrequency'] = state.postdata?.payperiodfield;

      data.applicants[0]['otherIncomeSource'] = data.applicants[0].otherIncomeDescription;

      if (data.applicants[1]) {
        data.applicants[1]['otherIncomeSource'] = data.applicants[1].otherIncomeDescription;
        data.applicants[1]['income'] = data.applicants[1].employers[0].grossMonthlyIncome;
        data.applicants[1]['incomeFrequency'] = state.postdata?.cosignerpayperiodfield;
        delete data.applicants[1].otherIncomeDescription;
        if (data.applicants[1].otherMonthlyIncome === 0) {
          delete data.applicants[1].otherMonthlyIncome;
        }
      delete data.applicants[1].employers[0].grossMonthlyIncome;

      }
      delete data.applicants[0].otherIncomeDescription;
      delete data.applicants[0].employers[0].grossMonthlyIncome;
      delete data.applicants[0].employers[1].grossMonthlyIncome;


      //ends
      if (state.financeVehicleDataByVIN.make && !window.hideVehicleOfInterest) {
        data.vehicle.year = state.financeVehicleDataByVIN.year;
        data.vehicle.make = state.financeVehicleDataByVIN.make;
        data.vehicle.model = state.financeVehicleDataByVIN.model;
        data.vehicle.trim = state.financeVehicleDataByVIN.trim;
      }
      state.dealerTrackRequest = data;
    },
    [actiontypes.DEALER_TRACK_REF_ID](state, payload) {
      state.dealerTrackRefId = payload.dealRefId;
    },
    [actiontypes.SET_FINANCE_STEP_TWO_VALIDATION_ERROR](state, payload) {
      state.stepTwoValidationError = payload;
    },
    [actiontypes.SET_FINANCE_STEP_ONE_VALIDATION_ERROR](state, payload) {
      state.stepOneValidationError = payload;
    },
    [actiontypes.SET_FINANCE_WEB_SERVICE_PAYLOAD](state, payload) {
      state.webservicepayload = payload;
    },
    [actiontypes.SET_FINANCE_CBC_RESPONSE](state, payload) {
      state.cbcApiResponse = JSON.stringify(payload);
    },
    //popupStatus
    [actiontypes.CLOSE_MODAL_POPUP_TO_OPEN_EVENTDRIVEN](state, payload) {
      state.popupStatus = payload;
    },
    [actiontypes.SET_FINANCE_E_SIGN_ERROR](state, payload) {
      state.eSignSignatureError = payload;
    },
    [actiontypes.SET_EVENT_DRIVEN_SESSION_COUNT](state, payload) {
      state.eventDrivenSessionCount = payload;
    },
    [actiontypes.SET_LOG_LEAD_DATA](state, payload) {
      state.logLeadData = payload;
    },
    [actiontypes.SET_CBC_CREDIT_DATA](state, payload) {
      state.creditCBCPostData.applicants[0].firstName = payload.firstnamefield
        ? payload.firstnamefield
        : state.stepOneData.firstnamefield;
      state.creditCBCPostData.applicants[0].lastName = payload.lastnamefield
        ? payload.lastnamefield
        : state.stepOneData.lastnamefield;
      state.creditCBCPostData.applicants[0].otherMonthlyIncome = payload.additionalincomefield
        ? parseInt(payload.additionalincomefield)
        : 0;
      state.creditCBCPostData.applicants[0].otherIncomeDescription =
        payload.additionalincomesourcefield ? payload.additionalincomesourcefield : '';
      state.creditCBCPostData.applicants[0].dateOfBirth = payload.datepicker
        ? payload.datepicker
        : '';
      state.creditCBCPostData.applicants[0].emailAddress = payload.emailfield
        ? payload.emailfield
        : state.stepOneData.emailfield;

      //primary applicant address1
      state.creditCBCPostData.applicants[0].addresses[0].addressLine = payload.streetfield;
      state.creditCBCPostData.applicants[0].addresses[0].city = payload.citytfield;
      state.creditCBCPostData.applicants[0].addresses[0].status = payload.rentorownfield;
      state.creditCBCPostData.applicants[0].addresses[0].state = payload.statefield;
      state.creditCBCPostData.applicants[0].addresses[0].postalCode = payload.zipfield
        ? payload.zipfield
        : state.stepOneData.zipfield;
      state.creditCBCPostData.applicants[0].addresses[0].yearsAtAddress = parseInt(
        payload.addressyearstotalfield
      );
      state.creditCBCPostData.applicants[0].addresses[0].monthsAtAddress =
        payload.addressmonthstotalfield ? parseInt(payload.addressmonthstotalfield) : 0;
      state.creditCBCPostData.applicants[0].addresses[0].PaymentAmount = parseInt(
        payload.monthlypaymentfield
      );
      //primary applicant address2
      state.creditCBCPostData.applicants[0].addresses[1].addressLine = payload.previousstreetfield
        ? payload.previousstreetfield
        : '';
      state.creditCBCPostData.applicants[0].addresses[1].city = payload.previouscitytfield
        ? payload.previouscitytfield
        : '';
      state.creditCBCPostData.applicants[0].addresses[1].state = payload.previousstatefield
        ? payload.previousstatefield
        : '';
      state.creditCBCPostData.applicants[0].addresses[1].postalCode = payload.previouszipfield
        ? payload.previouszipfield
        : '';
      state.creditCBCPostData.applicants[0].addresses[1].yearsAtAddress =
        payload.previousaddressyearstotalfield
          ? parseInt(payload.previousaddressyearstotalfield)
          : 0;
      state.creditCBCPostData.applicants[0].addresses[1].monthsAtAddress =
        payload.previousaddressmonthstotalfield
          ? parseInt(payload.previousaddressmonthstotalfield)
          : 0;
      //primary employer1
      state.creditCBCPostData.applicants[0].employers[0].class = payload.employerclassfield;
      state.creditCBCPostData.applicants[0].employers[0].name = payload.employerfield;
      state.creditCBCPostData.applicants[0].employers[0].positionTitle = payload.titlefield;
      state.creditCBCPostData.applicants[0].employers[0].yearsAtEmployer = parseInt(
        payload.employmentyearsfield
      );
      state.creditCBCPostData.applicants[0].employers[0].monthsAtEmployer =
        payload.employmentmonthsfield ? parseInt(payload.employmentmonthsfield) : 0;
      state.creditCBCPostData.applicants[0].employers[0].grossMonthlyIncome = payload.incomefield
        ? parseInt(payload.incomefield)
        : 0;
      //primary employer1 address and phone
      state.creditCBCPostData.applicants[0].employers[0].address.addressLine =
        payload.employercitytfield;
      state.creditCBCPostData.applicants[0].employers[0].address.city = payload.employercitytfield;
      state.creditCBCPostData.applicants[0].employers[0].address.state = payload.employerstatefield;
      state.creditCBCPostData.applicants[0].employers[0].phoneNumber.areaCode =
        payload.workphonefield ? payload.workphonefield.substring(0, 3) : '';
      state.creditCBCPostData.applicants[0].employers[0].phoneNumber.prefix = payload.workphonefield
        ? payload.workphonefield.substring(3, 6)
        : '';
      state.creditCBCPostData.applicants[0].employers[0].phoneNumber.suffix = payload.workphonefield
        ? payload.workphonefield.substring(6)
        : '';
      //primary former employer address and phone
      state.creditCBCPostData.applicants[0].employers[1].class = payload.formeremployerclassfield;
      state.creditCBCPostData.applicants[0].employers[1].name = payload.formeremployerfield;
      state.creditCBCPostData.applicants[0].employers[1].positionTitle =
        payload.formeremployerpositionfield;
      state.creditCBCPostData.applicants[0].employers[1].yearsAtEmployer =
        payload.formeremployertimefield ? parseInt(payload.formeremployertimefield) : 0;
      state.creditCBCPostData.applicants[0].employers[1].monthsAtEmployer =
        payload.formeremployertimemonthsfield ? parseInt(payload.formeremployertimemonthsfield) : 0;
      state.creditCBCPostData.applicants[0].employers[1].grossMonthlyIncome =
        payload.formerincomefield ? parseInt(payload.formerincomefield) : 0;

      state.creditCBCPostData.applicants[0].employers[1].address.postalCode =
        payload.formeremployerzipfielde;
      state.creditCBCPostData.applicants[0].employers[1].address.addressLine =
        payload.formeremployercityfield;
      state.creditCBCPostData.applicants[0].employers[1].address.city =
        payload.formeremployercityfield;
      state.creditCBCPostData.applicants[0].employers[1].address.state =
        payload.formeremployerstatefield;
      state.creditCBCPostData.applicants[0].employers[1].phoneNumber.areaCode =
        payload.formeremployerphonefield ? payload.formeremployerphonefield.substring(0, 3) : '';
      state.creditCBCPostData.applicants[0].employers[1].phoneNumber.prefix =
        payload.formeremployerphonefield ? payload.formeremployerphonefield.substring(3, 6) : '';
      state.creditCBCPostData.applicants[0].employers[1].phoneNumber.suffix =
        payload.formeremployerphonefield ? payload.formeremployerphonefield.substring(6) : '';

      //SSN
      //Phone Numbers
      state.creditCBCPostData.applicants[0].phoneNumbers[0].areaCode = payload.phonefield
        ? payload.phonefield.substring(0, 3)
        : state.stepOneData.phonefield.substring(0, 3);
      state.creditCBCPostData.applicants[0].phoneNumbers[0].prefix = payload.phonefield
        ? payload.phonefield.substring(3, 6)
        : state.stepOneData.phonefield.substring(3, 6);
      state.creditCBCPostData.applicants[0].phoneNumbers[0].suffix = payload.phonefield
        ? payload.phonefield.substring(6)
        : state.stepOneData.phonefield.substring(6);
      state.creditCBCPostData.applicants[0].ids[1].issuer = payload.driverlicensestatefield;
      state.creditCBCPostData.applicants[0].ids[0].value = payload.ssnfield;
      state.creditCBCPostData.applicants[0].ids[1].value = payload.driverlicensefield;
      //cosigner
      if (state.iscoapplicant !== '1' && payload.ssnfield) {
        state.creditCBCPostData.applicants.splice(1, 1);
      }
      if (state.iscoapplicant === '1') {
        state.creditCBCPostData.applicants[1].firstName = payload.cosignerfirstnamefield;
        state.creditCBCPostData.applicants[1].lastName = payload.ccosignerlastnamefield;
        state.creditCBCPostData.applicants[1].dateOfBirth = payload.cosignerdateofbirthfield
          ? payload.cosignerdateofbirthfield
          : '';
        state.creditCBCPostData.applicants[1].emailAddress = payload.cosigneremailfield;
        state.creditCBCPostData.applicants[1].otherMonthlyIncome =
          payload.cosigneradditionalincomefield
            ? parseInt(payload.cosigneradditionalincomefield)
            : 0;
        state.creditCBCPostData.applicants[1].otherIncomeDescription =
          payload.cosigneradditionalincomesourcefield
            ? payload.cosigneradditionalincomesourcefield
            : '';

        //co applicant address1
        state.creditCBCPostData.applicants[1].addresses[0].addressLine =
          payload.cosignerstreetfield;
        state.creditCBCPostData.applicants[1].addresses[0].city = payload.cosignercitytfield;
        state.creditCBCPostData.applicants[1].addresses[0].status = payload.cosignerrentorownfield;
        state.creditCBCPostData.applicants[1].addresses[0].state = payload.cosignerstatefield;
        state.creditCBCPostData.applicants[1].addresses[0].postalCode = payload.cosignerzipfield;
        state.creditCBCPostData.applicants[1].addresses[0].yearsAtAddress =
          payload.cosigneraddressyearstotalfield
            ? parseInt(payload.cosigneraddressyearstotalfield)
            : 0;
        state.creditCBCPostData.applicants[1].addresses[0].monthsAtAddress =
          payload.cosigneraddressmonthstotalfield
            ? parseInt(payload.cosigneraddressmonthstotalfield)
            : 0;
        state.creditCBCPostData.applicants[1].addresses[0].PaymentAmount =
          payload.cosignermonthlypaymentfield ? parseInt(payload.cosignermonthlypaymentfield) : 0;
        //co applicant address2
        state.creditCBCPostData.applicants[1].addresses[1].addressLine =
          state.creditPostData.applicants[1].addresses[1].addressLine1;
        state.creditCBCPostData.applicants[1].addresses[1].city =
          state.creditPostData.applicants[1].addresses[1].city;
        state.creditCBCPostData.applicants[1].addresses[1].state =
          state.creditPostData.applicants[1].addresses[1].state;
        state.creditCBCPostData.applicants[1].addresses[1].postalCode =
          state.creditPostData.applicants[1].addresses[1].postalCode;
        state.creditCBCPostData.applicants[1].addresses[1].yearsAtAddress =
          state.creditPostData.applicants[1].addresses[1].yearsAtAddress;
        state.creditCBCPostData.applicants[1].addresses[1].monthsAtAddress =
          state.creditPostData.applicants[1].addresses[1].monthsAtAddress;
        //co employer1
        state.creditCBCPostData.applicants[1].employers[0].class =
          payload.cosigneremployerclassfield;
        state.creditCBCPostData.applicants[1].employers[0].name = payload.cosigneremployerfield;
        state.creditCBCPostData.applicants[1].employers[0].positionTitle =
          payload.cosignerpositionfield;
        state.creditCBCPostData.applicants[1].employers[0].yearsAtEmployer =
          payload.cosigneremploymentlengthyearsfield
            ? parseInt(payload.cosigneremploymentlengthyearsfield)
            : 0;
        state.creditCBCPostData.applicants[1].employers[0].monthsAtEmployer =
          payload.cosigneremploymentmonthsfield
            ? parseInt(payload.cosigneremploymentmonthsfield)
            : 0;
        state.creditCBCPostData.applicants[1].employers[0].grossMonthlyIncome =
          payload.cosignermonthlyincomefield ? parseInt(payload.cosignermonthlyincomefield) : 0;

        //co employer1 address and phone
        state.creditCBCPostData.applicants[1].employers[0].address.addressLine =
          payload.cosigneremployercityfield;
        state.creditCBCPostData.applicants[1].employers[0].address.city =
          payload.cosigneremployercityfield;
        state.creditCBCPostData.applicants[1].employers[0].address.state =
          payload.cosigneremployerstatefield;
        state.creditCBCPostData.applicants[1].employers[0].phoneNumber.areaCode =
          payload.cosigneremploymerphonefield
            ? payload.cosigneremploymerphonefield.substring(0, 3)
            : '';
        state.creditCBCPostData.applicants[1].employers[0].phoneNumber.prefix =
          payload.cosigneremploymerphonefield
            ? payload.cosigneremploymerphonefield.substring(3, 6)
            : '';
        state.creditCBCPostData.applicants[1].employers[0].phoneNumber.suffix =
          payload.cosigneremploymerphonefield
            ? payload.cosigneremploymerphonefield.substring(6)
            : '';

        //phone numbers
        state.creditCBCPostData.applicants[1].phoneNumbers[0].areaCode =
          payload.cosignermobilephonefield ? payload.cosignermobilephonefield.substring(0, 3) : '';
        state.creditCBCPostData.applicants[1].phoneNumbers[0].prefix =
          payload.cosignermobilephonefield ? payload.cosignermobilephonefield.substring(3, 6) : '';
        state.creditCBCPostData.applicants[1].phoneNumbers[0].suffix =
          payload.cosignermobilephonefield ? payload.cosignermobilephonefield.substring(6) : '';
        //SSN
        state.creditCBCPostData.applicants[1].ids[1].issuer = payload.codriverlicensestatefield;
        state.creditCBCPostData.applicants[1].ids[1].value = payload.codriverlicensefield;
        state.creditCBCPostData.applicants[1].ids[0].value = payload.cosignerssnfield;
      }
    },
    [actiontypes.SET_CAMPAIGNID_ACCOUNTID_DEALERGROUP](state) {
      if (window.isDealerGroup && window.showDealerSelection) {
        if (parseInt(window.childAccountId) && parseInt(window.childCampaignId)) {
          state.creditPostData.campaignId = window.childCampaignId;
          state.creditPostData.accountId = window.childAccountId;
        }
      }
    },
    [actiontypes.SET_FINANCE_VEHICLE_DATA_BY_VIN](state, payload) {
      state.financeVehicleDataByVIN.year = payload.year ? payload.year : 0;
      state.financeVehicleDataByVIN.make = payload.make ? payload.make : '';
      state.financeVehicleDataByVIN.model = payload.model ? payload.model : '';
      state.financeVehicleDataByVIN.trim = payload.trim ? payload.trim : '';
      state.financeVehicleDataByVIN.vehicleStockNumber = payload.stock ? payload.stock : '';
      state.financeVehicleDataByVIN.vehicleVin = payload.vin ? payload.vin : '';
    },
    [actiontypes.SET_COAPPLICANT_PREVIOUS_ADDRESS](state, payload) {
      if (state.creditPostData.applicants[1]) {
        state.creditPostData.applicants[1].addresses[1].addressLine1 = payload.previousstreetfield;
        state.creditPostData.applicants[1].addresses[1].addressLine2 = payload.previousstreetfield;
        state.creditPostData.applicants[1].addresses[1].city = payload.previouscitytfield;
        state.creditPostData.applicants[1].addresses[1].state = payload.previousstatefield;
        state.creditPostData.applicants[1].addresses[1].postalCode = payload.previouszipfield;
        state.creditPostData.applicants[1].addresses[1].yearsAtAddress =
          payload.previousaddressyearstotalfield
            ? parseInt(payload.previousaddressyearstotalfield)
            : 0;
        state.creditPostData.applicants[1].addresses[1].monthsAtAddress =
          payload.previousaddressmonthstotalfield
            ? parseInt(payload.previousaddressmonthstotalfield)
            : 0;
      }
    },
    [actiontypes.SET_CREDIT_R1_ADDITIONAL_DATA](state, payload) {
      state.creditR1PostData.financeType = payload.financeType;
      state.creditR1PostData.pricing.price = payload.pricing.price;
      state.creditR1PostData.pricing.currency = payload.pricing.currency;
      state.creditR1PostData.pricing.type = payload.pricing.type;
      state.creditR1PostData.relationshipDescription = payload.relationshipDescription;
    },
    incrementCurrentStep(state) {
      state.currentstep++;
      state.currentComponent = 'financing-step-' + state.currentstep;
    },
    decrementCurrentStep(state) {
      if (state.currentstep > 0) {
        state.currentstep--;
        state.currentComponent = 'financing-step-' + state.currentstep;
      }
    },
    setCurrentStep(state, payload) {
      state.currentstep = payload;
      state.currentComponent = 'financing-step-' + state.currentstep;
    },
    [actiontypes.SET_COAPPLICANT](state, payload) {
      state.iscoapplicant = payload;
    },
    [actiontypes.SET_SUCCESS_MESSAGE](state, payload) {
      state.successmessage = payload;
    },

    [actiontypes.SET_FINANCE_DATA](state, payload) {
      if (payload.firstnamefield && payload.lastnamefield) {
        state.stepOneData = payload;
      }

      let postdata = state.postdata;
      let updatedPostdata = { ...postdata, ...payload };
      state.postdata = updatedPostdata;
    },

    [actiontypes.SET_LOADING](state, payload) {
      state.isloading = payload;
    },
    [actiontypes.SET_ERROR_MESSAGE](state, payload) {
      state.errormessage = payload;
    },
    [actiontypes.SET_LOGLEADSAVE_ID](state, payload) {
      state.logleadsaveid = payload;
    },
    [actiontypes.SET_CREDIT_APPLICANT_ID](state, payload) {
      if (payload > 0) {
        state.elendSuccess = true;
      } else {
        state.elendError = true;
      }
      state.creditPostData.applicationId = payload;
    },
    [actiontypes.SHOW_FINANCING_TEXT_MODAL](state, payload) {
      state.showTextModal = payload;
    },
    [actiontypes.SET_CREDIT_FINANCE_DATA](state, payload) {
      //vehicle info
      state.creditPostData.vehicle.vin = payload.vinfield ? payload.vinfield : '';
      state.creditPostData.vehicle.make = payload.vehiclemakefield ? payload.vehiclemakefield : '';
      state.creditPostData.vehicle.model = payload.vehiclemodelfield
        ? payload.vehiclemodelfield
        : '';
      state.creditPostData.vehicle.trim = payload.vehicletrimfield ? payload.vehicletrimfield : '';
      if (payload.vehicleyearfield) {
        state.creditPostData.vehicle['year'] = payload.vehicleyearfield;
      }
      //type primary
      state.creditPostData.logLeadItemID = state.logleadsaveid;
      state.creditPostData.applicants[0].relationship = payload.relationshipfield;
      state.creditPostData.applicants[0].firstName = payload.firstnamefield;
      state.creditPostData.applicants[0].lastName = payload.lastnamefield;
      state.creditPostData.applicants[0].emailAddress = payload.emailfield;
      state.creditPostData.applicants[0].dateOfBirth = payload.datepicker ? payload.datepicker : '';
      state.creditPostData.applicants[0].otherMonthlyIncome = payload.additionalincomefield
        ? parseInt(payload.additionalincomefield)
        : 0;
      state.creditPostData.applicants[0].otherIncomeDescription =
        payload.additionalincomesourcefield ? payload.additionalincomesourcefield : '';
      state.creditPostData.applicants[0].housing.type = payload.rentorownfield;
      state.creditPostData.applicants[0].housing.payment = parseInt(payload.monthlypaymentfield);

      state.creditPostData.applicants[0].addresses[1].addressLine1 = payload.previousstreetfield
        ? payload.previousstreetfield
        : '';
      state.creditPostData.applicants[0].addresses[1].city = payload.previouscitytfield
        ? payload.previouscitytfield
        : '';
      state.creditPostData.applicants[0].addresses[1].state = payload.previousstatefield
        ? payload.previousstatefield
        : '';
      state.creditPostData.applicants[0].addresses[1].postalCode = payload.previouszipfield
        ? payload.previouszipfield
        : '';
      state.creditPostData.applicants[0].addresses[1].yearsAtAddress =
        payload.previousaddressyearstotalfield
          ? parseInt(payload.previousaddressyearstotalfield)
          : 0;
      state.creditPostData.applicants[0].addresses[1].monthsAtAddress =
        payload.previousaddressmonthstotalfield
          ? parseInt(payload.previousaddressmonthstotalfield)
          : 0;
      state.creditPostData.applicants[0].addresses[0].addressLine1 = payload.streetfield;
      state.creditPostData.applicants[0].addresses[0].addressLine2 = payload.streetfield;
      state.creditPostData.applicants[0].addresses[0].city = payload.citytfield;
      state.creditPostData.applicants[0].addresses[0].state = payload.statefield;
      state.creditPostData.applicants[0].addresses[0].postalCode = payload.zipfield;
      state.creditPostData.applicants[0].addresses[0].yearsAtAddress = parseInt(
        payload.addressyearstotalfield
      );
      state.creditPostData.applicants[0].addresses[0].monthsAtAddress =
        payload.addressmonthstotalfield ? parseInt(payload.addressmonthstotalfield) : 0;

      state.creditPostData.applicants[0].employers[0].class = payload.employerclassfield;
      state.creditPostData.applicants[0].employers[0].name = payload.employerfield;
      state.creditPostData.applicants[0].employers[0].positionTitle = payload.titlefield;
      state.creditPostData.applicants[0].employers[0].yearsAtEmployer = parseInt(
        payload.employmentyearsfield
      );
      state.creditPostData.applicants[0].employers[0].monthsAtEmployer =
        payload.employmentmonthsfield ? parseInt(payload.employmentmonthsfield) : 0;
      state.creditPostData.applicants[0].employers[0].grossMonthlyIncome = payload.incomefield
        ? parseInt(payload.incomefield)
        : 0;
      state.creditPostData.applicants[0].employers[0].address.city = payload.employercitytfield;
      state.creditPostData.applicants[0].employers[0].address.state = payload.employerstatefield;
      state.creditPostData.applicants[0].employers[0].address.yearsAtAddress = parseInt(
        payload.employmentyearsfield
      );
      state.creditPostData.applicants[0].employers[0].address.monthsAtAddress =
        payload.employmentmonthsfield ? parseInt(payload.employmentmonthsfield) : 0;
      state.creditPostData.applicants[0].employers[0].phoneNumber.areaCode = payload.workphonefield
        ? payload.workphonefield.substring(0, 3)
        : '';
      state.creditPostData.applicants[0].employers[0].phoneNumber.prefix = payload.workphonefield
        ? payload.workphonefield.substring(3, 6)
        : '';
      state.creditPostData.applicants[0].employers[0].phoneNumber.suffix = payload.workphonefield
        ? payload.workphonefield.substring(6)
        : '';
      //former employer
      state.creditPostData.applicants[0].employers[1].class = payload.formeremployerclassfield;
      state.creditPostData.applicants[0].employers[1].name = payload.formeremployerfield;
      state.creditPostData.applicants[0].employers[1].positionTitle =
        payload.formeremployerpositionfield;
      state.creditPostData.applicants[0].employers[1].yearsAtEmployer =
        payload.formeremployertimefield ? parseInt(payload.formeremployertimefield) : 0;
      state.creditPostData.applicants[0].employers[1].monthsAtEmployer =
        payload.formeremployertimemonthsfield ? parseInt(payload.formeremployertimemonthsfield) : 0;
      state.creditPostData.applicants[0].employers[1].grossMonthlyIncome = payload.formerincomefield
        ? parseInt(payload.formerincomefield)
        : 0;

      state.creditPostData.applicants[0].employers[1].address.city =
        payload.formeremployercityfield;
      state.creditPostData.applicants[0].employers[1].address.state =
        payload.formeremployerstatefield;
      state.creditPostData.applicants[0].employers[1].address.yearsAtAddress =
        payload.formeremployertimefield ? parseInt(payload.formeremployertimefield) : 0;
      state.creditPostData.applicants[0].employers[1].address.monthsAtAddress =
        payload.formeremployertimemonthsfield ? parseInt(payload.formeremployertimemonthsfield) : 0;
      state.creditPostData.applicants[0].employers[1].phoneNumber.areaCode =
        payload.formeremployerphonefield ? payload.formeremployerphonefield.substring(0, 3) : '';
      state.creditPostData.applicants[0].employers[1].phoneNumber.prefix =
        payload.formeremployerphonefield ? payload.formeremployerphonefield.substring(3, 6) : '';
      state.creditPostData.applicants[0].employers[1].phoneNumber.suffix =
        payload.formeremployerphonefield ? payload.formeremployerphonefield.substring(6) : '';
      state.creditPostData.applicants[0].employers[1].address.postalCode =
        payload.formeremployerzipfielde;

      //former employer

      state.creditPostData.applicants[0].ids[0].issuer = payload.driverlicensestatefield;
      state.creditPostData.applicants[0].ids[0].value = payload.driverlicensefield?.replace(
        /\s/g,
        ''
      );
      state.creditPostData.applicants[0].ids[1].value = payload.ssnfield?.replace(/\s/g, '');
      state.creditPostData.applicants[0].phoneNumbers[0].areaCode = payload.phonefield
        ? payload.phonefield.substring(0, 3)
        : '';
      state.creditPostData.applicants[0].phoneNumbers[0].prefix = payload.phonefield
        ? payload.phonefield.substring(3, 6)
        : '';
      state.creditPostData.applicants[0].phoneNumbers[0].suffix = payload.phonefield
        ? payload.phonefield.substring(6)
        : '';
      //type cobuyer
      if (state.iscoapplicant !== '1' && payload.ssnfield) {
        state.creditPostData.applicants.splice(1, 1);
      }
      if (state.iscoapplicant === '1') {
        state.creditPostData.applicants[1].relationship = payload.cosignerrelationshipfield
          ? payload.cosignerrelationshipfield
          : '';
        state.creditPostData.applicants[1].firstName = payload.cosignerfirstnamefield;
        state.creditPostData.applicants[1].lastName = payload.ccosignerlastnamefield;
        state.creditPostData.applicants[1].emailAddress = payload.cosigneremailfield;
        state.creditPostData.applicants[1].phoneNumbers[0].areaCode =
          payload.cosignermobilephonefield ? payload.cosignermobilephonefield.substring(0, 3) : '';
        state.creditPostData.applicants[1].phoneNumbers[0].prefix = payload.cosignermobilephonefield
          ? payload.cosignermobilephonefield.substring(3, 6)
          : '';
        state.creditPostData.applicants[1].phoneNumbers[0].suffix = payload.cosignermobilephonefield
          ? payload.cosignermobilephonefield.substring(6)
          : '';
        state.creditPostData.applicants[1].dateOfBirth = payload.cosignerdateofbirthfield
          ? payload.cosignerdateofbirthfield
          : '';
        state.creditPostData.applicants[1].otherMonthlyIncome =
          payload.cosigneradditionalincomefield
            ? parseInt(payload.cosigneradditionalincomefield)
            : 0;
        state.creditPostData.applicants[1].otherIncomeDescription =
          payload.cosigneradditionalincomesourcefield
            ? payload.cosigneradditionalincomesourcefield
            : '';
        state.creditPostData.applicants[1].housing.type = payload.cosignerrentorownfield;
        state.creditPostData.applicants[1].housing.payment = payload.cosignermonthlypaymentfield
          ? parseInt(payload.cosignermonthlypaymentfield)
          : 0;

        state.creditPostData.applicants[1].addresses[0].addressLine1 = payload.cosignerstreetfield;
        state.creditPostData.applicants[1].addresses[0].addressLine2 = payload.cosignerstreetfield;
        state.creditPostData.applicants[1].addresses[0].city = payload.cosignercitytfield;
        state.creditPostData.applicants[1].addresses[0].state = payload.cosignerstatefield;
        state.creditPostData.applicants[1].addresses[0].postalCode = payload.cosignerzipfield;
        state.creditPostData.applicants[1].addresses[0].yearsAtAddress =
          payload.cosigneraddressyearstotalfield
            ? parseInt(payload.cosigneraddressyearstotalfield)
            : 0;
        state.creditPostData.applicants[1].addresses[0].monthsAtAddress =
          payload.cosigneraddressmonthstotalfield
            ? parseInt(payload.cosigneraddressmonthstotalfield)
            : 0;
        state.creditPostData.applicants[1].employers[0].class = payload.cosigneremployerclassfield;
        state.creditPostData.applicants[1].employers[0].name = payload.cosigneremployerfield;
        state.creditPostData.applicants[1].employers[0].positionTitle =
          payload.cosignerpositionfield;
        state.creditPostData.applicants[1].employers[0].yearsAtEmployer =
          payload.cosigneremploymentlengthyearsfield
            ? parseInt(payload.cosigneremploymentlengthyearsfield)
            : 0;
        state.creditPostData.applicants[1].employers[0].monthsAtEmployer =
          payload.cosigneremploymentmonthsfield
            ? parseInt(payload.cosigneremploymentmonthsfield)
            : 0;
        state.creditPostData.applicants[1].employers[0].grossMonthlyIncome =
          payload.cosignermonthlyincomefield ? parseInt(payload.cosignermonthlyincomefield) : 0;
        state.creditPostData.applicants[1].employers[0].address.city =
          payload.cosigneremployercityfield;
        state.creditPostData.applicants[1].employers[0].address.state =
          payload.cosigneremployerstatefield;
        state.creditPostData.applicants[1].employers[0].address.yearsAtAddress =
          payload.cosigneremploymentlengthyearsfield
            ? parseInt(payload.cosigneremploymentlengthyearsfield)
            : 0;
        state.creditPostData.applicants[1].employers[0].address.monthsAtAddress =
          payload.cosigneremploymentmonthsfield
            ? parseInt(payload.cosigneremploymentmonthsfield)
            : 0;
        state.creditPostData.applicants[1].employers[0].phoneNumber.areaCode =
          payload.cosigneremploymerphonefield
            ? payload.cosigneremploymerphonefield.substring(0, 3)
            : '';
        state.creditPostData.applicants[1].employers[0].phoneNumber.prefix =
          payload.cosigneremploymerphonefield
            ? payload.cosigneremploymerphonefield.substring(3, 6)
            : '';
        state.creditPostData.applicants[1].employers[0].phoneNumber.suffix =
          payload.cosigneremploymerphonefield
            ? payload.cosigneremploymerphonefield.substring(6)
            : '';

        state.creditPostData.applicants[1].ids[0].issuer = payload.codriverlicensestatefield;
        state.creditPostData.applicants[1].ids[0].value = payload.codriverlicensefield;
        state.creditPostData.applicants[1].ids[0].value = payload.codriverlicensefield?.replace(
          /\s/g,
          ''
        );
        state.creditPostData.applicants[1].ids[1].value = payload.cosignerssnfield?.replace(
          /\s/g,
          ''
        );
      }
    },
  },
  actions: {
    [actiontypes.CONSUMER_EVENT_CALL](context) {
      const firstName = context.state.postdata.firstnamefield || '';
      const lastName = context.state.postdata.lastnamefield || '' || '';
      const email = context.state.postdata.emailfield || '';
      const phoneNumber = context.state.postdata.phonefield || '';
      const zip = context.state.postdata.zipfield || '';
      const vin = context.state.creditPostData?.vehicle?.vin;
      let eventModel = {
        ...Events.consumerEventModel,
        logLeadItemId: context.state.logleadsaveid || 0,
        consumerEventId: Events.eventsConstants.submitFullgetFinancing,
        pin: window.userDetails.userpin,
        vin: vin || '',
        stockNumber: '',
        offerId: 0,
        firstName: firstName,
        lastName: lastName,
        emailAddress: email,
        phoneNumber: phoneNumber,
        mobilePhone: phoneNumber,
        zip: zip,
      };
      if (
        eventModel.vin?.toLowerCase() ===
        context.state.financeVehicleDataByVIN?.vehicleVin?.toLowerCase()
      ) {
        eventModel['stockNumber'] = context.state.financeVehicleDataByVIN.vehicleStockNumber;
      }
      Events.logConsumerEvent(eventModel);
    },
    [actiontypes.CALL_FINANCE_WEB_SERVICE](context, payload) {
      let url = `${window.logsApiUrl}/WebServiceLog`;
      let res = '';
      try{
         res = JSON.parse(payload?.response);
      }
      catch{
        res=''
      }
      let status=res?.data?.success===true?'success':'failure';
      let name = `${context.state.postdata?.firstnamefield} ${context.state.postdata?.lastnamefield}`;
      payload = {
        ...payload,
        status: status,
        name: name,
        year: context.state.postdata?.vehicleyearfield?.toString(),
        make: context.state.postdata?.vehiclemakefield,
        model: context.state.postdata?.vehiclemodelfield,
        vin: context.state.postdata?.vinfield,
        accountId: context.state?.accountId,
        campaignId: context.state?.campaignId,
      };
      axios
        .post(url, payload)
        .then(() => {
          console.log('success');
        })
        .catch(() => {
          console.log('error');
        });
    },
    [actiontypes.SUBMIT_CBC_CREDIT_DATA](context) {
      let creditCbcPostUrl = window.cbcApiBaseUrl + '/CreditCbc/SubmitApplication';
      let postData = context.state.creditCBCPostData;
      //web service log starts
      let logRequest = { ...context.state.webservicepayload };
      logRequest.message = 'Calling from UI for Cbc api';
      logRequest.typeId = 20;
      postData.logLeadItemID = context.state.logleadsaveid ? context.state.logleadsaveid : 0;
      logRequest.request = JSON.stringify(postData);
      //web service log ends
      //check cookie exist or not
      let cookieValue = '';
      let cookie = document.cookie.indexOf('cbcCookie') >= 0;
      if (cookie) {
        let pairs = document.cookie.split('; '),
          count = pairs.length,
          parts;
        while (count--) {
          parts = pairs[count].split('=');
          if (parts[0] === 'cbcCookie') cookieValue = JSON.parse(parts[1]);
        }
        postData['keys'] = cookieValue;
      }
      //check cookie ends
      axios
        .post(creditCbcPostUrl, postData)
        .then((response) => {
          context.commit(actiontypes.SET_FINANCE_CBC_RESPONSE, response);

          if (response.data.keys) {
            let cbcCookieKeys = JSON.stringify(response.data.keys);
            let cookieExpiryDate = new Date(new Date().getTime() + 3600 * 1000 * 24 * 365 * 10);
            document.cookie = `cbcCookie=${cbcCookieKeys};path=/;expires=${cookieExpiryDate}`;
          }
          logRequest.response = JSON.stringify(response);
          context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
        })
        .catch((error) => {
          logRequest.response = JSON.stringify(error);
          context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
          console.log('error');
        });
    },
    [actiontypes.SUBMIT_CREDIT_R1_DATA](context) {
      let creditR1PostUrl = window.routeOneApiBaseUrl + '/CreditR1/SubmitApplication';
      let logRequest = { ...context.state.webservicepayload };
      let creditR1PostData = JSON.parse(JSON.stringify(context.state.creditPostData));
      creditR1PostData.applicants[0]['middleName'] = context.state.stepOneData.middleName;
      delete creditR1PostData.applicationId;
      delete creditR1PostData.applicants[0].Relationship;
      delete creditR1PostData.applicants[0].suffix;
      delete creditR1PostData.applicants[0].bank;
      if (creditR1PostData?.applicants[1]) {
        delete creditR1PostData.applicants[1].middleName;
        delete creditR1PostData.applicants[1].suffix;
        delete creditR1PostData.applicants[1].bank;
      }
      delete creditR1PostData.relationship;
      creditR1PostData['financeType'] = context.state.creditR1PostData.financeType;
      creditR1PostData.vehicle['pricing'] = context.state.creditR1PostData.pricing;
      if (creditR1PostData?.applicants[1]) {
        creditR1PostData.applicants[1].relationshipDescription =
          context.state.creditR1PostData.relationshipDescription;
      }
      //replacing object keys for R1 API
      creditR1PostData.applicants[0]['otherIncomeSource'] =
        creditR1PostData.applicants[0].otherIncomeDescription;
      //new changes
      creditR1PostData.applicants[0]['otherIncome'] =
        creditR1PostData.applicants[0].otherMonthlyIncome || 0;
      creditR1PostData.applicants[0]['otherIncomeFrequency'] =
        context.state.postdata?.payperiodfield;
      creditR1PostData.applicants[0].employers[0]['grossIncome'] =
        creditR1PostData.applicants[0].employers[0].grossMonthlyIncome;
        creditR1PostData.applicants[0].employers[1]['grossIncome'] =
          creditR1PostData.applicants[0]?.employers[1]?.grossMonthlyIncome;
        creditR1PostData.applicants[0].employers[0]['incomeFrequency'] =
          context.state.postdata?.payperiodfield;
        creditR1PostData.applicants[0].employers[1]['incomeFrequency'] =
          context.state.postdata?.payperiodfield;
        //new changes ends
        if (creditR1PostData.applicants[1]) {
          creditR1PostData.applicants[1]['otherIncomeSource'] =
            creditR1PostData.applicants[1].otherIncomeDescription;
          //adding hot fix for other income null issue
          creditR1PostData.applicants[1]['otherIncome'] =
            creditR1PostData.applicants[1]['otherMonthlyIncome'] || 0;
          creditR1PostData.applicants[1]['otherIncomeFrequency'] =
            context.state.postdata?.cosignerpayperiodfield;
          creditR1PostData.applicants[1].employers[0]['incomeFrequency'] =
            context.state.postdata?.cosignerpayperiodfield;

          creditR1PostData.applicants[1].employers[0]['grossIncome'] =
            creditR1PostData.applicants[1].employers[0].grossMonthlyIncome;
          //adding hot fix ends
          delete creditR1PostData.applicants[1].otherIncomeDescription;
          delete creditR1PostData.applicants[1].otherMonthlyIncome;
          delete creditR1PostData.applicants[1].employers[0].grossMonthlyIncome;
        }
        delete creditR1PostData.applicants[0].otherIncomeDescription;
        delete creditR1PostData.applicants[0].otherMonthlyIncome;
        delete creditR1PostData.applicants[0].employers[0].grossMonthlyIncome;
        delete creditR1PostData.applicants[0].employers[1].grossMonthlyIncome;

      if (creditR1PostData.vehicle.year) {
        creditR1PostData.vehicle.year = parseInt(creditR1PostData.vehicle.year);
      }

      //replacing ends
      logRequest.message = 'Calling from UI for Credit R1 api';
      logRequest.typeId = 12;
      logRequest.request = JSON.stringify(creditR1PostData);
      axios
        .post(creditR1PostUrl, creditR1PostData)
        .then((response) => {
          logRequest.response = JSON.stringify(response);
          context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          if (response?.data?.success) {
            context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
          }
        })
        .catch((error) => {
          logRequest.response = JSON.stringify(error);
          context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          console.log('error');
        });
    },
    [actiontypes.SUBMIT_FINANCE_DATA](context, payload) {
      let posturl = `${window.ApiBaseUrl}/BuyerCall/BuyerCallSave?campaingId=${window.campaignId}&accountId=${window.accountId}`;
      let creditPostUrl = window.eLendApiBaseUrl + '/Credit/SubmitApplication';
      //web service log starts
      let logRequest = { ...context.state.webservicepayload };
      //web service log ends
      //checking vehicle details with vin starts
      payload.vehiclemakefield = context.state.financeVehicleDataByVIN.make
        ? context.state.financeVehicleDataByVIN.make
        : payload.vehiclemakefield;
      payload.vehiclemodelfield = context.state.financeVehicleDataByVIN.model
        ? context.state.financeVehicleDataByVIN.model
        : payload.vehiclemodelfield;
      payload.vehicletrimfield = context.state.financeVehicleDataByVIN.trim
        ? context.state.financeVehicleDataByVIN.trim
        : payload.vehicletrimfield;
      payload.vehicleyearfield = context.state.financeVehicleDataByVIN.year
        ? parseInt(context.state.financeVehicleDataByVIN.year)
        : parseInt(payload.vehicleyearfield);
      //checking vehicle details with vin ends
      context.commit(actiontypes.SET_CREDIT_FINANCE_DATA, payload);
      //required only for credit submit not for buyercall

      delete payload.cosignerrelationshipfield;
      delete payload.employerclassfield;
      delete payload.formeremployerclassfield;
      delete payload.cosigneremployerclassfield;
      delete payload.relationshipfield;
      let formdata = new FormData();
      for (let key in payload) {
        formdata.append(key, payload[key]);
      }
      let creditPostData = { ...context.state.creditPostData };
      //elend description starts here
      let date = new Date();
      if (context.state.e_lendDisclosure.text) {
        creditPostData['disclosures'] = [
          {
            token: context.state.e_lendDisclosure.token,
            ipAddress: window.ipaddress,
            source: 'website',
            dateTimeAccepted: date.toISOString(),
            applicantType: creditPostData.applicants.length > 1 ? 'Cobuyer' : 'Primary',
          },
        ];
      }
      //elend description ends here
      if (window.enableElend) {
        logRequest.message = 'Calling from UI for Elend api';
        logRequest.typeId = 9;
        logRequest.request = JSON.stringify(creditPostData);
        axios
          .post(creditPostUrl, creditPostData)
          .then((response) => {
            logRequest.response = JSON.stringify(response);
            context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          })
          .catch((error) => {
            logRequest.response = JSON.stringify(error);
            context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          });
      } else if (window.enableBuyerCall) {
        logRequest.message = 'Calling from UI for Buyer Call api';
        logRequest.applicationSource = 'Offersites UI-MyCreditApp';
        logRequest.typeId = 28;
        logRequest.request = JSON.stringify(context.state.postdata);
        axios
          .post(posturl, formdata)
          .then((response) => {
            logRequest.response = JSON.stringify(response);
            context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          })
          .catch((error) => {
            let failedResponse = {
              response: error?.response,
              errorInfo: `useOnePageDesign:${window.useOnePageDesign},type:fullsubmit,message:${error?.message}`,
            };
            logRequest.response = JSON.stringify(failedResponse);
            context.dispatch(actiontypes.CONSUMER_EVENT_CALL);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          });
      } else {
        // No action needed for other cases.
      }
    },
    [actiontypes.SUBMIT_FINANCE_PARTIAL_DATA](context, payload) {
      let posturl = `${window.ApiBaseUrl}/BuyerCall/BuyerCallSave?campaingId=${window.campaignId}&isPartialSubmit=true&accountId=${window.accountId}`;

      /** required only for credit submit not for buyercall **/
      delete payload.cosignerrelationshipfield;
      delete payload.employerclassfield;
      delete payload.formeremployerclassfield;
      delete payload.cosigneremployerclassfield;
      delete payload.relationshipfield;
      let logRequest = { ...context.state.webservicepayload };
      logRequest.request = JSON.stringify(payload);
      let formdata = new FormData();
      for (let key in payload) {
        formdata.append(key, payload[key]);
      }

      if (window.financeAppDealerCode) {
        context.commit(actiontypes.SET_LOADING, true);

        axios
          .post(posturl, formdata, {
            headers: { 'Partial-submit': 'yes' },
          })
          .then((response) => {
            context.commit(actiontypes.SET_FINANCE_DATA, {
              'lead-id-field': response.data.lead,
            });
            context.commit(actiontypes.INCREMENT_FINANCING_STEP);
            context.commit(actiontypes.SET_LOADING, false);
            logRequest.response = JSON.stringify(response);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          })
          .catch((err) => {
            let failedResponse = {
              response: err.response,
              errorInfo: `useOnePageDesign:${window.useOnePageDesign},type:partial,message:${err?.message}`,
            };
            context.commit(actiontypes.SET_ERROR_MESSAGE, 'Something went wrong. Please Try Again');
            context.commit(actiontypes.INCREMENT_FINANCING_STEP);
            context.commit(actiontypes.SET_LOADING, false);
            logRequest.response = JSON.stringify(failedResponse);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          });
      }
    },
    [actiontypes.SUBMIT_CREDIT_PARTIAL_DATA](context, payload) {
      let campaignID = context.state.creditPostData.campaignId
        ? context.state.creditPostData.campaignId
        : window.campaignId;
      let accountId = context.state.creditPostData.accountId
        ? context.state.creditPostData.accountId
        : window.accountId;
      let partialPostData = {
        campaignId: parseInt(campaignID),
        accountId: parseInt(accountId),
        logLeadItemID: context.state.logleadsaveid ? context.state.logleadsaveid : 0,
        applicants: [
          {
            type: 'Primary',
            firstName: payload.firstnamefield,
            lastName: payload.lastnamefield,
            emailAddress: payload.emailfield,
            phoneNumbers: [
              {
                type: 'cell',
                areaCode: payload.phonefield ? payload.phonefield.substring(0, 3) : '',
                prefix: payload.phonefield ? payload.phonefield.substring(3, 6) : '',
                suffix: payload.phonefield ? payload.phonefield.substring(6) : '',
              },
            ],
          },
        ],
        sessionId: window.tid,
      };
      if (context.state.creditPostData.applicationId > 0) {
        partialPostData['applicationId'] = context.state.creditPostData.applicationId;
      }
      let logRequest = { ...context.state.webservicepayload };
      let creditPostUrl = window.eLendApiBaseUrl + '/Credit/SubmitApplication';
      let previousEmail = context.state.creditPostData.applicants[0].emailAddress;
      let previousFirstName = context.state.creditPostData.applicants[0].firstName;
      let previousLastName = context.state.creditPostData.applicants[0].lastName;
      let previousZipCode = context.state.creditPostData.applicants[0].addresses[0].postalCode;
      let previousPhoneNumber =
        context.state.creditPostData.applicants[0].phoneNumbers[0].areaCode +
        context.state.creditPostData.applicants[0].phoneNumbers[0].prefix +
        context.state.creditPostData.applicants[0].phoneNumbers[0].suffix;
      logRequest.request = JSON.stringify(partialPostData);
      if (
        payload.firstnamefield !== previousFirstName ||
        payload.lastnamefield !== previousLastName ||
        payload.emailfield !== previousEmail ||
        payload.phonefield !== previousPhoneNumber ||
        payload.zipfield !== previousZipCode
      ) {
        context.commit(actiontypes.SET_LOADING, true);

        axios
          .post(creditPostUrl, partialPostData, {
            headers: { 'Partial-submit': 'yes' },
          })
          .then((response) => {
            context.commit(actiontypes.SET_CREDIT_FINANCE_DATA, payload);
            context.commit(actiontypes.SET_CREDIT_APPLICANT_ID, response.data.applicationId);
            context.commit(actiontypes.SET_LOADING, false);
            logRequest.response = JSON.stringify(response);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          })
          .catch((error) => {
            context.commit(actiontypes.SET_CREDIT_APPLICANT_ID, 0);
            console.log('credit response', error);
            context.commit(actiontypes.SET_LOADING, false);
            logRequest.response = JSON.stringify(error);
            context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
          });
      }
    },

    async [actiontypes.DEALER_TRACK_PARTIAL_LEAD](context) {
      const url = window.dealerTrackApiUrl + '/api/DealerTrack/CreatePartialLead';
      const data = {
        campaignId: context.state.campaignId,
        accountId: context.state.accountId,
        logLeadItemID: context.state.logleadsaveid,
        firstName: context.state.postdata.firstnamefield,
        lastName: context.state.postdata.lastnamefield,
        email: context.state.postdata.emailfield,
        phone: context.state.postdata.phonefield,
        sessionId: window.tid,
      };
      return axios.post(url, data);
    },
    async [actiontypes.DEALER_TRACK_CREATE_FULL_LEAD](context) {
      let data = { ...context.state.dealerTrackRequest, sessionId: window.tid };
      const url = window.dealerTrackApiUrl + '/api/DealerTrack/CreateFullLead';
      try {
        return await axios.post(url, data);
      } catch (error) {
        console.error('DEALER_TRACK_CREATE_FULL_LEAD error:', error);
        throw error;
      }
    },
    async [actiontypes.DEALER_TRACK_UPDATE_FULL_LEAD](context) {
      let data = { ...context.state.dealerTrackRequest, sessionId: window.tid };
      let dealerRefId = context.state.dealerTrackRefId;
      const url = window.dealerTrackApiUrl + `/api/DealerTrack/UpdateLead?dealRefId=${dealerRefId}`;
      try {
        return await axios.post(url, data);
      } catch (error) {
        console.error('DEALER_TRACK_UPDATE_FULL_LEAD error:', error);
        throw error;
      }
    },
    [actiontypes.DEALER_TRACK_LOG](context) {
      let logRequest = { ...context.state.webservicepayload };
      let dealerTrackRequest = { ...context.state.dealerTrackRequest };
      let dealerTrackResponse = { ...context.state.dealerTrackResponse };
      logRequest.message = 'Calling from UI for Dealer Track Api';
      logRequest.typeId = 58;
      console.log('dealerTrackRequest', dealerTrackRequest);
      logRequest.request = JSON.stringify(dealerTrackRequest);
      logRequest.response = JSON.stringify(dealerTrackResponse);
      context.dispatch(actiontypes.CALL_FINANCE_WEB_SERVICE, logRequest);
    },
    [actiontypes.CALL_ELEND_DISCLOSURE_API](context) {
      let url = `${window.eLendApiBaseUrl}/Credit/GetCreditConsentDisclosures?campaignId=${context.state.campaignId}&accountId=${context.state.accountId}&SessionId=${window.tid}`;
      axios
        .get(url)
        .then((response) => {
          context.commit(actiontypes.E_LEND_DISCLOSURE_DATA, response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
